import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

/**
 * Text + arrow control for nested admin screens (trek sub-forms, standalone forms).
 * Prefer `to` + `state`; use `onNavigate` when you need side effects (e.g. refs) before navigating.
 */
export default function AdminBackLink({ to, state, label = 'Back', onNavigate, className = '' }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (typeof onNavigate === 'function') {
      onNavigate();
      return;
    }
    if (to) {
      if (state !== undefined) navigate(to, { state });
      else navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      type="button"
      className={`module-back-link ${className}`.trim()}
      onClick={handleClick}
      aria-label={label}
    >
      <ArrowLeft size={18} strokeWidth={2} aria-hidden />
      <span>{label}</span>
    </button>
  );
}
